/**
 * Az első karaktert lowercaseli.
 * @param {string} str - A szöveg.
 * @returns {string} Az átalakított szöveg.
 */
function lcFirst (str) {
  return `${ str.charAt(0).toLowerCase() }${ str.slice(1) }`
}

module.exports.lcFirst = lcFirst
